import ActionHomeSection from "../components/HomeSection/ActionHomeSection";
import HomeCallToAction from "../components/HomeSection/HomeCallToAction";
import HomeLogo from "../components/HomeSection/HomeLogo";
import HomeSection from "../components/HomeSection/HomeSection";
import InformationHomeSection from "../components/HomeSection/InformationHomeSection";
import NewsHomeSection from "../components/HomeSection/NewsHomeSection";
import ServiceHomeSection from "../components/HomeSection/ServiceHomeSection";
import StatisticHomeSection from "../components/HomeSection/StatisticHomeSection";
import WorkHomeSection from "../components/HomeSection/WorkHomeSection";

const Home = () => {
  return (
    <>
      <div className="">
        <HomeSection />
      </div>

      <div className="">
        <ServiceHomeSection />
      </div>
      {/* <WaterSection />     */}

      <StatisticHomeSection />

      <NewsHomeSection />

      <ActionHomeSection />
      <InformationHomeSection />
      <WorkHomeSection />

      <HomeCallToAction />

      <HomeLogo className="relative flex items-center justify-center h-full p-4 md:p-40" />

      <div className="flex justify-center "></div>
    </>
  );
};

export default Home;
